import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { UserSessionPort } from 'user/port/user-session.port';

@Injectable()
export class UserSessionAdapter implements UserSessionPort {
	private _domain: string;
	private _expiration: Date;
	private _topDomain: string;
	private _isConnectedAs: boolean;
	private _jwt$: BehaviorSubject<string>;

	constructor(
		private cookieService: CookieService,
		@Inject(DOCUMENT) private document: Document
	) {
		this._domain = /(.*\.){0,}(.+\..*|localhost)/.exec(
			this.document.location.hostname
		)[2];
		this._topDomain = this._domain === 'localhost' ? null : `.${this._domain}`;
		this._jwt$ = new BehaviorSubject(this.getJwToken());
		this._expiration = new Date(2147483647000);
	}

	public getJwToken(): string {
		if (environment.production) {
			return this._loadJwtToken();
		} else {
			switch (environment.autoConnectionRole) {
				case 'COACHEE':
					return environment.tokens.coachee;
				default:
					return this._loadJwtToken();
			}
		}
	}

	public observeJwToken(): Observable<string> {
		return this._jwt$.pipe(distinctUntilChanged());
	}

	public closeSession(): void {
		if (this._isConnectedAs) {
			this.cookieService.delete('AS_JW_TOKEN', '/', this._topDomain);
		} else {
			this.cookieService.delete('JW_TOKEN', '/', this._topDomain);
		}
		this._jwt$.next(this.getJwToken());
	}

	private _loadJwtToken(): string {
		const jwToken = this.cookieService.get('JW_TOKEN');
		const asJwToken = this.cookieService.get('AS_JW_TOKEN');

		if (asJwToken) {
			this._isConnectedAs = true;
			return asJwToken;
		} else {
			this._isConnectedAs = false;
			return jwToken;
		}
	}
}
